<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :expand-on-hover="true"
    touchless
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    :mini-variant.sync="drawer"
    width="260"
    v-bind="$attrs"
    permanent
    absolute
    :value="true"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props"/>
    </template>

    <v-list-item two-line class="px-0">
      <v-list-item-content class="py-0">
        <v-list-item-title
          class="ma-0 font-weight-regular display-2 d-flex align-items-center"
        >
                    <span v-show="drawer == true">
                        <span class="logo-mini font-weight-medium display-1">
                            <span>
                                <img
                                  src="../../../../assets/img/logo-small.png"
                                  width="30"
                                  alt="Boss24"
                                />
                            </span>
                            <span class="logo-description">Boss24</span>
                        </span>
                    </span>
          <span
            v-show="drawer == false"
            class="d-flex w-100 align-items-center content-around"
          >
                        <span v-show="drawer == false" class="logo">
                            <img src="../../../../assets/img/logo.png" width="80" alt="Boss24"/>
                        </span>
                        <span class="app-name display-1">CLient-Bank</span>
                    </span>
          <!--
<v-btn icon small @click.stop="showMenu()" class="hide-menu ml-auto toggle-menu-chevron">
  <v-icon v-if="drawer">mdi-chevron-right</v-icon>

  <v-icon v-else>mdi-chevron-left</v-icon>
          </v-btn>-->
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1"/>

    <v-list dense nav>
      <base-item-group :item="profile" class="photo-profile-sidebar"/>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>

      <template v-for="(item, i) in computedItems">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
          <!--  -->
        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item"/>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DashboardCoreDrawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    mini: true,
    items: [
      {
        icon: 'mdi-cash-100',
        title: 'Client-bank',
        to: '/',
      },
      {
        icon: 'mdi-ip',
        title: 'IpNumbers',
        to: '/digest/ipnumbers',
      },
      {
        icon: 'mdi-sim',
        title: 'sim_cards',
        to: '/digest/simcards',
      },
      {
        icon: 'mdi-city',
        title: 'Companies',
        to: '/digest/companies',
      },
      /*{
          icon: 'mdi-account-group',
          title: 'Users',
          to: '/users',
      },*/
      /*{
          icon: 'mdi-account-multiple-plus-outline',
          title: 'Invites',
          to: '/invites',
      },*/
      /*{
          icon: 'business_center',
          title: 'Counterparties',
          to: '/counterparties',
      },*/
      {
        icon: 'mdi-phone-log',
        title: 'CallsHistory_0',
        group: '/callshistory',
        children: [
          {
            title: 'CallsHistory_1',
            to: 'callshistory_1',
          },
          {
            title: 'CallsHistory_2',
            to: 'callshistory_2',
          },
        ],
      },
      {
        group: '/scenarios',
        icon: 'mdi-script-text-outline',
        title: 'Scenarios',
        children: [
          {
            title: 'General',
            to: 'general',
          },
          {
            title: 'ForSims',
            to: 'forsims',
          },
          {
            title: 'ForServers',
            to: 'forservers',
          },
          {
            title: 'CallForwarding',
            to: 'callforwarding',
          },
        ],
      },
      /*{
        group: '/digest',
        icon: 'mdi-car-shift-pattern',
        title: 'Digest',
        children: [
          {
            icon: 'mdi-city',
            title: 'Companies',
            to: 'companies',
          },
          {
            icon: 'mdi-sim',
            title: 'sim_cards',
            to: 'simcards',
          },
          {
            icon: 'mdi-ip',
            title: 'IpNumbers',
            to: 'ipnumbers',
          },
        ],
      },*/
      {
        group: '/integrations',
        icon: 'mdi-merge',
        title: 'Integrations',
        /*to: '/integrations',*/
        children: [
          {
            icon: 'mdi-server',
            title: 'ExternalServer',
            to: 'externalserver',
          },
        ],
      },
    ],
  }),

  computed: {
    ...mapState(['barColor', 'barImage'], ['drawer']),
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
    computedItems () {
      return this.items.map(this.mapItem)
    },
    profile () {
      return {
        avatar: true,
        group: '',
        title: this.$t('avatar'),
        children: [
          {
            href: '',
            title: this.$t('my-profile'),
          },
          {
            to: '',
            title: this.$t('edit-profile'),
          },
          {
            to: 'pages/login',
            title: this.$t('exit'),
          },
        ],
      }
    },
  },

  watch: {
    '$vuetify.breakpoint.smAndDown' (val) {
      this.$emit('update:expandOnHover', !val)
    },
  },

  methods: {
    mapItem (item) {
      return {
        ...item,
        children: item.children
          ? item.children.map(this.mapItem)
          : undefined,
        title: this.$t(item.title),
      }
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
    }),
    showMenu () {
      this.$store.state.drawer = !this.$store.state.drawer
    },
  },
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  position: fixed
  z-index: 4

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px

.cb-logo
  height: 50px !important
  width: 50px !important
  position: absolute
  top: 7px
  left: 16px
</style>
